import appI18nInstance from 'i18n';
import { SubscriptionPlanNameEnum } from 'types/users.types';

type ReturnType = {
  title: string;
  subtitle: string;
  description: string;
  name: string;
  displayName: string;
  discountBadgeText?: string;
  subscriptionText: string;
  badge?: { Icon: any; text: string };
  featuresTitle?: string;
  sidebarText?: string;
};

const useSubscriptionPlanInfo = (
  planName: SubscriptionPlanNameEnum,
): ReturnType => {
  const plansInformation = {
    [SubscriptionPlanNameEnum.free]: {
      name: SubscriptionPlanNameEnum.free,
      displayName: appI18nInstance.t(SubscriptionPlanNameEnum.free),
      title: 'eu.accountable.free',
      subtitle: 'subscriptions_screen.plans.recommendation_subtitle',
      description: '',
      subscriptionText: 'subscriptions_screen.plans.recommendation_subtitle',
    },
    [SubscriptionPlanNameEnum.trial1]: {
      name: SubscriptionPlanNameEnum.free,
      displayName: appI18nInstance.t(SubscriptionPlanNameEnum.free),
      title: '',
      subtitle: 'subscriptions_screen.billed_free',
      description: '',
      subscriptionText: 'subscriptions_screen.plans.recommendation_title',
      featuresTitle: appI18nInstance.t('subscriptions_screen.plans.includes', {
        planName: appI18nInstance.t(SubscriptionPlanNameEnum.free),
      }),
    },
    [SubscriptionPlanNameEnum.pro1]: {
      name: SubscriptionPlanNameEnum.pro12,
      displayName: appI18nInstance.t(SubscriptionPlanNameEnum.pro12),
      title: 'subscriptions_screen.plans.pro.title',
      subtitle: '',
      description: 'subscriptions_screen.plans.pro.description',
      subscriptionText: 'subscriptions_screen.plans.subscribed_title',
      featuresTitle: appI18nInstance.t('subscriptions_screen.plans.includes', {
        planName: appI18nInstance.t(SubscriptionPlanNameEnum.pro12),
      }),
    },
    [SubscriptionPlanNameEnum.pro12]: {
      name: SubscriptionPlanNameEnum.pro12,
      displayName: appI18nInstance.t(SubscriptionPlanNameEnum.pro12),
      title: 'subscriptions_screen.plans.pro.title',
      subtitle: '',
      description: 'subscriptions_screen.plans.pro.description',
      subscriptionText: 'subscriptions_screen.plans.subscribed_title',
      featuresTitle: appI18nInstance.t('subscriptions_screen.plans.includes', {
        planName: appI18nInstance.t(SubscriptionPlanNameEnum.pro12),
      }),
    },
    [SubscriptionPlanNameEnum.basic1]: {
      name: SubscriptionPlanNameEnum.basic12,
      displayName: appI18nInstance.t(SubscriptionPlanNameEnum.basic12),
      title: 'subscriptions_screen.plans.basic.title',
      subtitle: '',
      description: 'subscriptions_screen.plans.basic.description',
      subscriptionText: 'subscriptions_screen.plans.recommendation_title',
      featuresTitle: appI18nInstance.t('subscriptions_screen.plans.includes', {
        planName: appI18nInstance.t(SubscriptionPlanNameEnum.basic12),
      }),
    },
    [SubscriptionPlanNameEnum.basic12]: {
      name: SubscriptionPlanNameEnum.basic12,
      displayName: appI18nInstance.t(SubscriptionPlanNameEnum.basic12),
      title: 'subscriptions_screen.plans.basic.title',
      subtitle: '',
      description: 'subscriptions_screen.plans.basic.description',
      subscriptionText: 'subscriptions_screen.plans.recommendation_title',
      featuresTitle: appI18nInstance.t('subscriptions_screen.plans.includes', {
        planName: appI18nInstance.t(SubscriptionPlanNameEnum.basic12),
      }),
    },
    [SubscriptionPlanNameEnum.small1]: {
      name: appI18nInstance.t(SubscriptionPlanNameEnum.small12),
      displayName: appI18nInstance.t(SubscriptionPlanNameEnum.small12),
      title: appI18nInstance.t('subscriptions_screen.plans.small_n.title'),
      subtitle: '',
      description: '',
      subscriptionText: 'subscriptions_screen.plans.subscribed_title',
      featuresTitle: appI18nInstance.t('subscriptions_screen.plans.includes', {
        planName: appI18nInstance.t(SubscriptionPlanNameEnum.small12),
      }),
    },
    [SubscriptionPlanNameEnum.small12]: {
      name: appI18nInstance.t(SubscriptionPlanNameEnum.small12),
      displayName: appI18nInstance.t(SubscriptionPlanNameEnum.small12),
      title: appI18nInstance.t('subscriptions_screen.plans.small_n.title'),
      subtitle: '',
      description: '',
      subscriptionText: 'subscriptions_screen.plans.subscribed_title',
      featuresTitle: appI18nInstance.t('subscriptions_screen.plans.includes', {
        planName: appI18nInstance.t(SubscriptionPlanNameEnum.small12),
      }),
    },
    [SubscriptionPlanNameEnum.small_max1]: {
      name: SubscriptionPlanNameEnum.small_max12,
      displayName: appI18nInstance.t(SubscriptionPlanNameEnum.small_max12),
      title: 'subscriptions_screen.plans.small_max.title',
      subtitle: '',
      description: '',
      subscriptionText: 'subscriptions_screen.plans.subscribed_title',
      featuresTitle: appI18nInstance.t(
        'subscriptions_screen.plans.includes_plus',
        {
          referencePlan: appI18nInstance.t(SubscriptionPlanNameEnum.small12),
        },
      ),
    },
    [SubscriptionPlanNameEnum.small_max12]: {
      name: SubscriptionPlanNameEnum.small_max12,
      displayName: appI18nInstance.t(SubscriptionPlanNameEnum.small_max12),
      title: 'subscriptions_screen.plans.small_max.title',
      subtitle: '',
      description: '',
      subscriptionText: 'subscriptions_screen.plans.subscribed_title',
      featuresTitle: appI18nInstance.t(
        'subscriptions_screen.plans.includes_plus',
        {
          referencePlan: appI18nInstance.t(SubscriptionPlanNameEnum.small12),
        },
      ),
    },
    [SubscriptionPlanNameEnum.pro_max1]: {
      name: SubscriptionPlanNameEnum.pro_max12,
      displayName: appI18nInstance.t(SubscriptionPlanNameEnum.pro_max12),
      title: 'subscriptions_screen.plans.pro_max.title',
      subtitle: '',
      description: '',
      subscriptionText: 'subscriptions_screen.plans.subscribed_title',
      featuresTitle: appI18nInstance.t(
        'subscriptions_screen.plans.includes_plus',
        {
          referencePlan: appI18nInstance.t(SubscriptionPlanNameEnum.pro12),
        },
      ),
    },
    [SubscriptionPlanNameEnum.pro_max12]: {
      name: SubscriptionPlanNameEnum.pro_max12,
      displayName: appI18nInstance.t(SubscriptionPlanNameEnum.pro_max12),
      title: 'subscriptions_screen.plans.pro_max.title',
      subtitle: '',
      description: '',
      subscriptionText: 'subscriptions_screen.plans.subscribed_title',
      featuresTitle: appI18nInstance.t(
        'subscriptions_screen.plans.includes_plus',
        {
          referencePlan: appI18nInstance.t(SubscriptionPlanNameEnum.pro12),
        },
      ),
    },
    [SubscriptionPlanNameEnum.e_invoicing1]: {
      name: appI18nInstance.t(SubscriptionPlanNameEnum.e_invoicing12),
      displayName: appI18nInstance.t(SubscriptionPlanNameEnum.e_invoicing12),
      title: appI18nInstance.t(SubscriptionPlanNameEnum.e_invoicing12),
      subtitle: appI18nInstance.t('plan_features.e_invoicing.title'),
      description: '',
      subscriptionText: appI18nInstance.t('plan_features.e_invoicing.title'),
      featuresTitle: appI18nInstance.t('pricing_plan.reference_plan.title', {
        referencePlanName: appI18nInstance.t(SubscriptionPlanNameEnum.free),
      }),
      sidebarText: appI18nInstance.t('plan_features.e_invoicing.sidebar_text'),
    },
    [SubscriptionPlanNameEnum.e_invoicing12]: {
      name: appI18nInstance.t(SubscriptionPlanNameEnum.e_invoicing12),
      displayName: appI18nInstance.t(SubscriptionPlanNameEnum.e_invoicing12),
      title: appI18nInstance.t(SubscriptionPlanNameEnum.e_invoicing12),
      subtitle: appI18nInstance.t('plan_features.e_invoicing.title'),
      description: '',
      subscriptionText: appI18nInstance.t('plan_features.e_invoicing.title'),
      featuresTitle: appI18nInstance.t('pricing_plan.reference_plan.title', {
        referencePlanName: appI18nInstance.t(SubscriptionPlanNameEnum.free),
      }),
      sidebarText: appI18nInstance.t('plan_features.e_invoicing.sidebar_text'),
    },
    [SubscriptionPlanNameEnum.bookkeeping1]: {
      name: appI18nInstance.t(SubscriptionPlanNameEnum.bookkeeping12),
      displayName: appI18nInstance.t(SubscriptionPlanNameEnum.bookkeeping12),
      title: appI18nInstance.t(SubscriptionPlanNameEnum.bookkeeping12),
      subtitle: appI18nInstance.t('plan_features.bookkeeping.title'),
      description: '',
      subscriptionText: appI18nInstance.t('plan_features.bookkeeping.title'),
      featuresTitle: appI18nInstance.t('pricing_plan.reference_plan.title', {
        referencePlanName: appI18nInstance.t(
          SubscriptionPlanNameEnum.e_invoicing12,
        ),
      }),
    },
    [SubscriptionPlanNameEnum.bookkeeping12]: {
      name: appI18nInstance.t(SubscriptionPlanNameEnum.bookkeeping12),
      displayName: appI18nInstance.t(SubscriptionPlanNameEnum.bookkeeping12),
      title: appI18nInstance.t(SubscriptionPlanNameEnum.bookkeeping12),
      subtitle: appI18nInstance.t('plan_features.bookkeeping.title'),
      description: '',
      subscriptionText: appI18nInstance.t('plan_features.bookkeeping.title'),
      featuresTitle: appI18nInstance.t('pricing_plan.reference_plan.title', {
        referencePlanName: appI18nInstance.t(
          SubscriptionPlanNameEnum.e_invoicing12,
        ),
      }),
    },
    [SubscriptionPlanNameEnum.taxes1]: {
      name: appI18nInstance.t(SubscriptionPlanNameEnum.taxes12),
      displayName: appI18nInstance.t(SubscriptionPlanNameEnum.taxes12),
      title: appI18nInstance.t(SubscriptionPlanNameEnum.taxes12),
      subtitle: appI18nInstance.t('plan_features.taxes.title'),
      description: '',
      subscriptionText: appI18nInstance.t('plan_features.taxes.title'),
      featuresTitle: appI18nInstance.t('pricing_plan.reference_plan.title', {
        referencePlanName: appI18nInstance.t(
          SubscriptionPlanNameEnum.bookkeeping12,
        ),
      }),
    },
    [SubscriptionPlanNameEnum.taxes12]: {
      name: appI18nInstance.t(SubscriptionPlanNameEnum.taxes12),
      displayName: appI18nInstance.t(SubscriptionPlanNameEnum.taxes12),
      title: appI18nInstance.t(SubscriptionPlanNameEnum.taxes12),
      subtitle: appI18nInstance.t('plan_features.taxes.title'),
      description: '',
      subscriptionText: appI18nInstance.t('plan_features.taxes.title'),
      featuresTitle: appI18nInstance.t('pricing_plan.reference_plan.title', {
        referencePlanName: appI18nInstance.t(
          SubscriptionPlanNameEnum.bookkeeping12,
        ),
      }),
    },
    [SubscriptionPlanNameEnum.max1]: {
      name: appI18nInstance.t(SubscriptionPlanNameEnum.max12),
      displayName: appI18nInstance.t(SubscriptionPlanNameEnum.max12),
      title: appI18nInstance.t(SubscriptionPlanNameEnum.max12),
      subtitle: appI18nInstance.t('plan_features.max.title'),
      description: '',
      subscriptionText: appI18nInstance.t('plan_features.max.title'),
      featuresTitle: appI18nInstance.t('pricing_plan.reference_plan.title', {
        referencePlanName: appI18nInstance.t(SubscriptionPlanNameEnum.taxes12),
      }),
    },
    [SubscriptionPlanNameEnum.max12]: {
      name: appI18nInstance.t(SubscriptionPlanNameEnum.max12),
      displayName: appI18nInstance.t(SubscriptionPlanNameEnum.max12),
      title: appI18nInstance.t(SubscriptionPlanNameEnum.max12),
      subtitle: appI18nInstance.t('plan_features.max.title'),
      description: '',
      subscriptionText: appI18nInstance.t('plan_features.max.title'),
      featuresTitle: appI18nInstance.t('pricing_plan.reference_plan.title', {
        referencePlanName: appI18nInstance.t(SubscriptionPlanNameEnum.taxes12),
      }),
    },
  };

  return plansInformation[planName as keyof typeof plansInformation] || {};
};

export default useSubscriptionPlanInfo;
